/**
 * @file カード有効期限年作成
 */
'use strict';
// utility class
import Common from '../util/_common';

/**
 * @classname FormCardYearView
 * @classdesc カード有効期限年作成
 */
export default class FormCardYearView {
	/**
	 * @constructor
	 * @param {jQuery} $e - 該当する jQuery オブジェクト
	 */
	constructor($e) {
		console.log('FormCardYearView.constructor');
		this._$e = $e;
		this.init();
	};


	/**
	 * 初期化
	 *
	 * @memberof FormCardYearView
	 * @return {undefined}
	 */
	init() {
		console.log('FormCardYearView.init');
		const date = new Date();
		const startYear = date.getFullYear() - 2000;
		const endYear = startYear + 20;
		let options = '';
		for(let i = startYear; i <= endYear; i++){
			options += `<option value="${i}">${i}</option>`;
		}
		$('.card_year').append(options);
	};
}
